var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2577_15590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 14C29.5304 14 30.0391 14.2107 30.4142 14.5858C30.7893 14.9609 31 15.4696 31 16V30C31 30.5304 30.7893 31.0391 30.4142 31.4142C30.0391 31.7893 29.5304 32 29 32H15C14.4696 32 13.9609 31.7893 13.5858 31.4142C13.2107 31.0391 13 30.5304 13 30V16C13 15.4696 13.2107 14.9609 13.5858 14.5858C13.9609 14.2107 14.4696 14 15 14H29ZM29 16H15V30H29V16ZM22.037 18.729C22.308 17.861 23.477 17.779 23.887 18.545L23.939 18.655L25.677 23H27C27.2549 23.0003 27.5 23.0979 27.6854 23.2728C27.8707 23.4478 27.9822 23.687 27.9972 23.9414C28.0121 24.1958 27.9293 24.4464 27.7657 24.6418C27.6021 24.8373 27.3701 24.9629 27.117 24.993L27 25H25.007C24.8259 25.0001 24.6481 24.9515 24.4922 24.8593C24.3364 24.7672 24.2081 24.6348 24.121 24.476L24.069 24.366L23.116 21.982L21.462 27.275C21.203 28.103 20.107 28.228 19.655 27.53L19.595 27.425L18.381 25H17C16.7451 24.9997 16.5 24.9021 16.3146 24.7272C16.1293 24.5522 16.0178 24.313 16.0028 24.0586C15.9879 23.8042 16.0707 23.5536 16.2343 23.3582C16.3979 23.1627 16.6299 23.0371 16.883 23.007L17 23H18.994C19.334 23 19.648 23.17 19.834 23.449L19.897 23.559L20.285 24.335L22.037 18.729Z",
    fill: "#D34829"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#D34829",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2577_15590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.5078e54bae77ffb435667228a69fce23.svg";
export { ForwardRef as ReactComponent };